const firebaseConfig = {
    apiKey: "AIzaSyBlNyIR-EyPQfzGjWaiIo4uCsmpjOLiSGw",
    authDomain: "newsapp-114ae.firebaseapp.com",
    databaseURL: "https://newsapp-114ae.firebaseio.com",
    projectId: "newsapp-114ae",
    storageBucket: "newsapp-114ae.appspot.com",
    messagingSenderId: "810047275369",
    appId: "1:810047275369:web:7bc50e0c1e936198f47df8"
};

export default firebaseConfig;
